export const UPDATE_CART_LOGIN_TOKENS = 'UPDATE_CART_LOGIN_TOKENS';

export const updateCartLoginTokens = (
    tokens: {
        store: string;
        token: string;
    }[],
) => ({ type: UPDATE_CART_LOGIN_TOKENS, tokens });
